import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { InputHandler as t } from "../../../input/InputHandler.js";
import { eventMatchesPointerAction as i } from "../../../input/handlers/support.js";

var a = /*#__PURE__*/function (_t) {
  _inherits(a, _t);

  var _super = _createSuper(a);

  function a(t, i) {
    var _this;

    _classCallCheck(this, a);

    _this = _super.call(this, !0), _this.view = t, _this.registerIncoming("double-click", i, function (t) {
      return _this._handleDoubleClick(t, i);
    });
    return _this;
  }

  _createClass(a, [{
    key: "_handleDoubleClick",
    value: function _handleDoubleClick(t, _a) {
      i(t.data, "primary") && (t.stopPropagation(), _a ? this.view.mapViewNavigation.zoomOut([t.data.x, t.data.y]) : this.view.mapViewNavigation.zoomIn([t.data.x, t.data.y]));
    }
  }]);

  return a;
}(t);

export { a as DoubleClickZoom };